import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import { Container } from '../../styles/GlobalStyles';

export default function Page403() {
   return (
      <Container>
         <FaInfoCircle size={40} />
         <br />
         <h2>Acesso negado</h2>
         <br />
         <p>
            Você não tem permissão para acessar esta página.
         </p>
      </Container>
   );
}
